export default __webpack_public_path__ + "static/media/MarketingContent.235f35ae.md";